module.exports = __webpack_public_path__ + "static/media/12import-28.b71ab17a.xlsx";